export default __webpack_public_path__ + "static/media/t11.7342f40b.jpg";